let canvasCtx: CanvasRenderingContext2D | null = null;
export const getCanvasContext = () => {
	if (typeof window !== 'undefined') {
		if (!canvasCtx) {
			const canvas = document.createElement('canvas');
			canvasCtx = canvas.getContext('2d');
		}
	}
	return canvasCtx;
};
